interface IProps {
    children: React.ReactNode;
}
const style = {
    width: "clamp(250px, 900px, 80dvw)",
    margin: "auto",
    padding: "var(--page-padding)",
};
const Page = ({ children }: IProps) => {
    return (
        <div className="page" style={style}>
            {children}
        </div>
    );
};
export default Page;
